<template>
  <section>
    <header class="header-image ken-burn-center light" data-parallax="true"
            data-natural-height="500" data-natural-width="1920" data-bleed="0"
            data-image-src="../media/header1_seraphim.jpg" data-offset="0">
      <div class="container">
        <h1>SERAPHIM</h1>
        <h2>MÓDULOS</h2>
      </div>
    </header>
    <main>
      <section class="section-base">
        <div class="container">
          <div class="row row-fit-lg">
            <div class="col-lg-12">
              <p align="justify">
                Como fabricante de produtos solares de classe mundial, a Seraphim é especializada em
                pesquisa, desenvolvimento, produção e vendas de produtos solares fotovoltaicos.
                Desde a sua fundação em 2011, a Seraphim alcançou conquistas significativas que
                ultrapassaram a maioria de seus principais concorrentes em termos de capacidade de
                produção e em número de projetos inovadores. A empresa mantém sua crença de que a
                inovação é o principal impulsionador do avanço por meio da busca de novas
                tecnologias e maior eficiência.<br><br>&nbsp;&nbsp;Credenciada como "Batch I Smart
                Manufacturing Plant" pelo governo de Jiangsu, o Witness Laboratory Accreditation
                Certificate (WMTC) pelo CSA 、 DEKRA e o CTF Laboratory Certificate pelo TUV SUD.
                Estes são exemplos dos esforços e conquistas da Seraphim em inovação na indústria. A
                Seraphim é líder na indústria fotovoltaica em termos de inovações tecnológicas. Está
                listada como fabricante de módulos solares Tier 1 pela BNEF. Atualmente conta com
                uma capacidade de produção global de 5,5 GW. Atendendo clientes em todo o mundo com
                produtos e serviços profissionais de alta qualidade. Até agora, mais de 11 produtos
                da GW Seraphim foram amplamente aplicados em mais de 40 países.

              </p>
              <img :src="require('Assets/images/photo_seraphim1.jpg')">
              <br>
              <iframe width="100%" height="315" src="https://www.youtube.com/embed/Uwl0gwZrp7g"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;
                      picture-in-picture"
                      allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </section>
      <MarcasParceiras></MarcasParceiras>
      <br><br>
    </main>
  </section>
</template>

<script>
import MarcasParceiras from 'Homepage/common/MarcasParceiras.vue';

export default {
  name: 'Seraphim',
  components: {
    MarcasParceiras,
  },
};
</script>

<style scoped>
header {
  height: 250px !important;
  background-image: url("../../assets/images/header1_seraphim.jpg");
}
header .container {
  padding-top: 50px !important;
}
header h2 {
  color: #0098da !important;
  line-height: 37px;
  text-transform: uppercase !important;
  font-weight: 700 !important;
  margin: 0 !important;
  font-size: 14px !important;
}

</style>
